module.exports = __webpack_public_path__ + "static/media/services.2861ea4a.svg";